/**
 * Header Layout
 *
 * @file header.js
 */

import $ from "jquery";

const header = (() => {
  const fixedHeader = () => {
    $(".header-lm .menu .item.product-menu").hover(function(){
      $(".desktop-sub-menu").addClass("active");
    }, function(){
      $(".desktop-sub-menu").removeClass("active");
    });
    $(".desktop-sub-menu").hover(function(){
      $(this).addClass("active");
      $(".mn-bg-overlay").addClass("active");
      $(".header-lm .menu").addClass("gray-hover");
    }, function(){
      $(".desktop-sub-menu").removeClass("active");
      $(".header-lm .menu .item").removeClass("active");
      $(".header-lm .menu").removeClass("gray-hover");
      $(".mn-bg-overlay").removeClass("active");
    });
    $(".desktop-sub-menu").mouseenter(function(){
      $(".header-lm .menu .item.product-menu").addClass("active");
    }); 
    $(".right .menu .item").hover(function(){
      $(".mn-bg-overlay").addClass("active");
    }, function(){
      $(".mn-bg-overlay").removeClass("active");
    });
    $(".search.spk-t, .mobile-search").on("click", function(){
      $(".full-search").addClass("active");
      $("html, body").addClass("hidden");
      $(".full-search input").focus();
    });
    $(".full-search-bg").on("click", function(){
      $(".full-search").removeClass("active");
      $("html, body").removeClass("hidden");
    });
  };


  const mobileHeader = () => {

    $(".mobile-menu-toggle").on("click",function(){
      $(this).toggleClass("active");
      $("html, body").toggleClass("hidden");
      $(".mobile-menu").toggleClass("active");
    });


    $(".menu-mn .item .mobile-sub-sv").on("click",function(){
      $(this).toggleClass("active");
      $(this).next(".mobile-sub-menu").toggleClass("active");
    });
  };


  const footerMenu = () => {

    $(".mobile-menu-title").on("click",function(){
      $(this).parent(".item").toggleClass("active");
    });
  };


  const init = () => {
    fixedHeader();
    mobileHeader();
    footerMenu();
  };

  return {
    init,
  };
})();

export default header;
